// Func = limiting Scope for this file
'use strict';
function successFunction(){
    window.location.href = "/thank-you-membership";
} 
(function(){
	function resizeWindow(){

	}

    let getClassLoadSvg = document.getElementById('svg-load');
    let bodyOpen = document.querySelector('body');

    //-------- this function add a class to an element that you need animate
        const timeAnimations = (element, classElement, timeAnimation) => {
            setTimeout(function () {
                element.classList.add(classElement);
            }, timeAnimation);
        }
    //-------- this function add a class to an element that you need animate

    //-------- this function add a class to an element that you need animate
		const removeTimeAnimations = (element, classElement, timeAnimation) => {
			setTimeout(function () {
				element.classList.remove(classElement);
			}, timeAnimation);
		}
    //-------- this function remove a class of an element that you need remove some animation

    //-------- this function run the code inside it, when the site charge
    function loadSite() {
        timeAnimations(bodyOpen, 'body-open', 800);
        if($('body#home').length > 0){
            if([...getClassLoadSvg.classList.contains('load')]){
                timeAnimations(getClassLoadSvg, 'close', 4000);
            }
        }
    }
    window.onload = loadSite;
    //-------- this function run the code inside it, when the site charge
    
    if(document.getElementById('giftCardCta')){
        document.getElementById('giftCardCta').addEventListener('click', function(e){
            if(document.getElementsByClassName('homepage').length > 0){
                e.preventDefault();
                let currentTarget = this.getAttribute('href').split('#')[1];
                animateTo(currentTarget);
            }
        })
    }

	$(document).ready(function () {

        // $('.upcoming-events').slick({
        //     arrows: true,
        //     infinite: true,
        //     slidesToShow: 3,
        //     slidesToScroll: 3
        // });


		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();


        $( "#footer #email-signup .signup-btn" ).insertAfter( "#email-signup .field:nth-child(4):not(.gdpr)" );

        $('[data-fancybox]').fancybox();


        if($('body#home').length > 0) {
            timeAnimations(getClassLoadSvg, 'load', 0);
            timeAnimations(getClassLoadSvg, 'bounce', 1500);

            let closeLoadPage = document.querySelector('.loading-page');
            timeAnimations(closeLoadPage, 'close-loading-page', 3500);

            let initfirstTextHome = document.querySelector('.js-first-title');
            let initSecondTextHome = [...document.getElementsByClassName('js-second-title')];
            initSecondTextHome.forEach(function (eachLetter) {
                if([...closeLoadPage.classList.contains('close-loading-page')]){
                    timeAnimations(initfirstTextHome, 'init-first-text-home', 7000);
                    timeAnimations(eachLetter, 'init-second-text-home', 7700);
                }
            });
        }

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		const burgerMenu = [...document.getElementsByClassName('burger')];
		const mainMenuSite = document.getElementById('primary-nav');
        const mainMenuList = document.getElementById('privary-navigation');
        const logoSite = document.getElementsByClassName('logo')[0];
        
        //Booking action


        //media
        $('.media-inquiry-btn').click(function(){
            $('#media-inquiry').fadeToggle();
        });
        $('.close-media-form').click(function(){
            $('#media-inquiry').fadeOut();
        });
        $('.login-show').click(function(){
            $('#frmLogin').slideToggle();
        });

        //$('.spa-menu').insertBefore('body#spa #header .container .main-menu');
        //$('.spa-menu').insertBefore('body#landing-page-month-offer #header .container .main-menu');
        
        //change text slick buttons tidal cove

        const changeTextSlickDots = (dotButton, newTextDot) => {

            let getTextDot = document.querySelector(dotButton) || [];
            getTextDot.textContent = newTextDot;

            // return getTextDot;
        };

        //change content become member on waterpage section

        let urlSite = window.location.host;
        let divideUrl = urlSite.split('/');

        const goBackWaterPark = document.querySelector('#waterpark .become-member__text-member, #spa .become-member__text-member, #landing-page-month-offer .become-member__text-member, body.bourbon-steak .become-member__text-member, body.aventura-restaurants .become-member__text-member') || [];
        let goBackWaterParkBtn = goBackWaterPark.innerHTML = ('<a href="/">Back to Turnberry Isle Country Club<span class="arrow-wp"></span></a>');

        // Link to ADA map
        if(document.getElementById('map') || document.getElementById('map-category') || document.getElementById('map-category-sidebar')){ 
            document.getElementById('content').insertAdjacentHTML('beforeend', '<a class="btn ada-map-button" href="/ada-map">Accessibility Map</a>'); 
        }

        //Reload Gif on hover Water-park landing page

        function reloadOnHover(){
            let gifElements = document.querySelectorAll('.js-splash-gif');
            gifElements.forEach(gifElem => {
                gifElem.addEventListener('mouseenter', _=>{
                    gifElem.setAttribute('src', '../assets/images/waterpark-splash.gif');
                });
                gifElem.addEventListener('mouseleave', _=>{
                    gifElem.removeAttribute('src');
                })
            })
        }
        reloadOnHover();

        

	});

    $(window).on('load', function() {
		equalize();

	});
    
    $("#post-486847 .spa-specials-module__text a.btn").html(function(buscayreemplaza, reemplaza) {
        return reemplaza.replace('Book Now ›', 'Purchase &#8250;');
    });
    $("#post-465123 .spa-specials-module__text a.btn").html(function(buscayreemplaza, reemplaza) {
        return reemplaza.replace('Book Now ›', 'Purchase &#8250;');
    });
    

    if ($(window).width() < 960) {
        $("#titles-465156").html(function(buscayreemplaza, reemplaza) {
            return reemplaza.replace('<h2 class="accordion-module__sec-title">CENTER FOR INTEGRATIVE MEDICINE &amp; HOLISTIC REJUVENATION</h2>', '<h2 class="accordion-module__sec-title">CENTER FOR INTEGRATIVE MEDICINE </br>&amp; HOLISTIC REJUVENATION</h2>');
        });
    }

    $.get("https://ipinfo.io", function (response) {
        console.log(response.country);
        
        if( response.country != 'CA' ){
            $('.canada').css('display', 'none');
        }
    }, "jsonp");
}());

const showMoreBtn = document.getElementsByClassName('show-more')[0];

if(showMoreBtn){
	showMoreBtn.addEventListener('click', _=>{
		document.querySelectorAll('.events-columns__info.hide,.press-block__item.hide').forEach(item =>{
			item.classList.remove('hide');
			showMoreBtn.classList.add('hide');
		})
	});
}